import { AxiosApi } from "../axiosInstance";
import { TokenResponse } from "../../types/auth";

export const exchangeGoogleCodeApi = async (
  code: string
): Promise<TokenResponse> => {
  const res = await AxiosApi.post<TokenResponse>(
    "/v1/admin/auth/google/token",
    { code }
  );
  return res as unknown as TokenResponse;
};
